"use client";
import featureIcon_4 from "@/assets/images/icon/Event2.svg";
import { correctUrlString, groupkebabCase } from "@/utils/utils";
import Image from "next/image";
import Link from "next/link";
import HandleCart from "@/components/common/HandleCart";
import { useRouter } from "next/navigation";

const PropertyOne = ({ events }: any) => {
  const router = useRouter();
  return (
    <>
      {/* {loading && <Loader />} */}
      <style>
        {`
     @media (max-width: 1024px) {
        .carts-dev {
          width: 100% !important;
        }
      }
    `}
      </style>

      <div
        className="m-10 about  d-flex justify-content-center items-content-center"
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          // justifyItems:"center",
          // padding: "17px",
          margin: "1%",
          gap: "10px",
          borderRadius: "1rem",
          backgroundColor: "#F5F5FF",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <div className="property-listing-five">
          <div className="">
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center px-1 px-lg-4 py-3 m-2 gap-2">
              <div className="d-flex flex-column">
                <h6
                  style={{
                    color: "#212121",
                    font: "Graphik",
                    fontSize: "40px",
                  }}
                >
                  Upcoming Events
                </h6>

                <div
                  style={{
                    color: "#666666",
                    fontFamily: "Graphik",
                    fontSize: "20px",
                  }}
                >
                  {" "}
                  Explore the latest and featured competitions, workshops, and
                  premium competitions.
                </div>
              </div>
              <div>
                <button
                  className="primary-button"
                  type="submit"
                  style={{
                    display: "flex",
                    fontSize: "14px",
                    // maxHeight: "40px",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px 20px",
                    cursor: "pointer",
                    width: "fit-content",
                    background: "#3F41D1",
                    border: "none",
                    borderRadius: "2rem",
                  }}
                  onClick={() => {
                    router.push("/events");
                  }}
                >
                  VIEW All
                </button>
              </div>
            </div>

            <div className="property-listing-five">
              <div className="container-fluid d-flex justify-content-center items-content-center">
                <div id="cart-section">
                  <div className="listing-header-filter mb-3 d-sm-flex justify-content-between align-items-center">
                    {events.length > 0 && (
                      <div className="row g-3">
                        {" "}
                        {/* Bootstrap row with gutter */}
                        {events.length > 0 && (
                          <div className="row g-3">
                            {events.map((item: any) => {
                              // const separator = "___";
                              // const parts = [
                              //   item?.group_name,
                              //   item?.Category,
                              //   item?.["Sub Type"],
                              //   // filter?.school?.value,
                              // ]
                              //   .filter(Boolean)
                              //   .map((part) => encodeURIComponent(part));

                              const pathname = `/event/${groupkebabCase(item?.["Sub Type"])}/${groupkebabCase(item?.Category)}/${groupkebabCase(item?.group_name)}`;

                              return (
                                <div
                                  key={item.id}
                                  className="col-12 col-sm-6 col-lg-4 d-flex"
                                >
                                  <div
                                    className="listing-card-one border-25 w-100 d-flex flex-column "
                                    style={{
                                      border: "1px solid rgba(0, 0, 0, 0.36)",
                                      borderRadius: "1rem",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="img-gallery p-2">
                                      <div className="position-relative overflow-hidden rounded-3">
                                        <div
                                          className="position-absolute d-flex justify-content-center align-items-center"
                                          style={{
                                            top: "12px",
                                            right: "12px",
                                            zIndex: 1,
                                            padding: "6px 12px",
                                            borderRadius: "34px",
                                            border: "1px solid #212121",
                                            color: "#310000",
                                            background: "#FFF",
                                            fontSize: "0.85rem",
                                            maxHeight: "32px",
                                          }}
                                        >
                                          {item?.["Sub Type"]}
                                        </div>

                                        <Link
                                          href={{ pathname }}
                                          className="d-block"
                                        >
                                          <Image
                                            src={
                                              correctUrlString(
                                                item?.image_link,
                                              )?.[0] || featureIcon_4
                                            }
                                            alt={item?.group_name || "Event"}
                                            width={500}
                                            height={300}
                                            className="w-100"
                                            style={{
                                              objectFit: "cover",
                                              height: "auto",
                                              maxHeight: "300px",
                                              minHeight: "180px",
                                              borderRadius: "0.5rem",
                                            }}
                                          />
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="property-info px-3">
                                      <div
                                        className="d-flex flex-column"
                                        // style={{ minHeight: "3rem" }}
                                      >
                                        <div className="title pb-1">
                                          <Link
                                            href={{ pathname }}
                                            className="d-block"
                                            style={{
                                              fontSize: "1.2rem",
                                              textDecoration: "none",
                                              color: "#000",
                                              fontFamily: "Graphik, sans-serif",
                                            }}
                                          >
                                            {item?.group_name}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="gap-2 px-3 pb-3">
                                      <HandleCart item={item} v3={true} />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyOne;
